import React from "react";
import CalculationInputListContainer from "./components";
import styles from "./CalculationInput.module.scss";

const CalculationInput: React.FC = () => (
  <div className={styles.pageContainer}>
    <CalculationInputListContainer />
  </div>
);

export default CalculationInput;
